let scrollOffset = 0;

export default {
    lock: (lockScrollBar) => {
        scrollOffset = window.scrollY;
        if (lockScrollBar) {
            document.body.classList.add("noscroll");
        }
        document.body.classList.add("locked");
        if (getComputedStyle(document.body).position === "fixed") {
            document.body.style.top = `-${scrollOffset}px`;
        }
    },
    unlock: () => {
        if (getComputedStyle(document.body).position === "fixed") {
            window.scrollTo(0, scrollOffset);
            document.body.style.top = "";
        }
        document.body.classList.remove("noscroll");
        document.body.classList.remove("locked");
    }
};
